var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1.5C7.17392 1.5 5.90215 2.00757 4.96447 2.91106C4.02678 3.81454 3.5 5.03993 3.5 6.31765C3.5 9.93088 8.5 14.5 8.5 14.5C8.5 14.5 13.5 9.93088 13.5 6.31765C13.5 5.03993 12.9732 3.81454 12.0355 2.91106C11.0979 2.00757 9.82608 1.5 8.5 1.5Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.49994C10.5 7.60451 9.60458 8.49994 8.50001 8.49994C7.39544 8.49994 6.50001 7.60451 6.50001 6.49994C6.50001 5.39537 7.39544 4.49994 8.50001 4.49994C9.60458 4.49994 10.5 5.39537 10.5 6.49994Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/Pin.d0ad4ae634ca96ee2ec0daf253b88a4d.svg";
export { ForwardRef as ReactComponent };